import { Link } from "react-router-dom";

export function UserLink(user) {
  if (user?.id === undefined || user?.id === null) {
    return <div>Not Set</div>;
  }
  return (
    <Link
      className={"text-axis-link text-decoration-none fw-bold"}
      to={{
        pathname: `/users/${user?.id}`,
      }}
    >
      {user?.surname}, {user?.forename}
    </Link>
  );
}

export function ShiftLink(shift) {
  if (shift?.id === null || shift?.id === undefined) {
    return <div>Not Set</div>;
  }

  return shift?.table === "shifts" ? (
    <Link
      className={"text-axis-link text-decoration-none"}
      to={{
        pathname: `/shifts/view/${shift.id}`,
      }}
    >
      {shift?.notificationId}
    </Link>
  ) : (
    <Link
      className={"text-axis-link text-decoration-none"}
      to={{
        pathname: `/archiveShifts/view/${shift.id}`,
      }}
    >
      {shift?.notificationId}
    </Link>
  );
}

export function ShiftLinkExplicit(shiftId, notificationId, table) {
  if (shiftId === null || shiftId === undefined) {
    return <div>Not Set</div>;
  }

  return table === "shifts" ? (
    <Link
      className={"text-axis-link text-decoration-none"}
      to={{
        pathname: `/shifts/view/${shiftId}`,
      }}
    >
      {notificationId}
    </Link>
  ) : (
    <Link
      className={"text-axis-link text-decoration-none"}
      to={{
        pathname: `/archiveShifts/view/${shiftId}`,
      }}
    >
      {notificationId}
    </Link>
  );
}

export function InboundPostmarkLink(postmarkId, text = "View") {
  if (postmarkId === null || postmarkId === undefined) return;

  return (
    <a
      href={
        "https://account.postmarkapp.com/servers/11930397/streams/inbound/messages/" +
        postmarkId
      }
      target="_blank"
      className={"text-decoration-none"}
    >
      <span className={"text-axis-link font-weight-bold"}>{text}</span>
    </a>
  );
}

export function OutboundPostmarkLink(postmarkId) {
  if (postmarkId === null || postmarkId === undefined) return;

  return (
    <a
      href={
        "https://account.postmarkapp.com/servers/11930397/streams/outbound/messages/" +
        postmarkId
      }
      target="_blank"
    >
      View
    </a>
  );
}
